import type { State } from '../../types';

export const getBoardId = (state: State): number => state.app.boardId;
